<template>
  <div class="articles-carousel-wrapp">
    <ArticlesCarousel
      :articles="posts"
      :title="title"
      :area="areaProp"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type {
    TArticlesCarouselWrapp,
    IContentArticlesCarouselWrapp,
  } from '~/types/components/ArticlesCarouselWrapp';
  import ArticlesCarousel from '~/components/ArticlesCarousel/ArticlesCarousel.vue';
  import type { TArticle } from '~/types/common';

  export default defineNuxtComponent({
    name: 'ArticlesCarouselWrapp',
    components: {
      ArticlesCarousel,
    },

    inject: {
      area: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      elem: {
        type: Object as PropType<IContentArticlesCarouselWrapp>,
        required: true,
      },
    },

    computed: {
      articlesCarousel(): TArticlesCarouselWrapp {
        return this.elem?.attributes;
      },

      posts(): Array<TArticle> {
        return this.articlesCarousel?.posts;
      },

      title(): string {
        return this.articlesCarousel?.title;
      },

      areaProp(): string {
        // @ts-expect-error injected functions are not typed in options API
        if (this.area) {
          // @ts-expect-error injected functions are not typed in options API
          return this.area();
        }
        return '';
      },
    },
  });
</script>

<style lang="scss" scoped>
  .articles-carousel-wrapp {
    :deep() {
      .articles-carousel-wrapper {
        padding: $spacing-6 $spacing-0;
      }
    }
  }
</style>
